<template>
  <section class="page-user-form">
    <Breadcrumbs :items="breadcrumbs"/>
    <div class="content">
      <rp-user-form
        @submit="addUser"
        :genders="genders"
        :roles="roleOption"
        :locales="availableLocales"
        :countries="countries"
        :hospitals="allHospitals"
        v-model="form"
        :surgeonRoleIsSelected="surgeonRoleIsSelected"
        :distributorRoleIsSelected="distributorRoleIsSelected"
        :hospitalAdminRoleIsSelected="hospitalAdminRoleIsSelected"
        />

        <terms/>
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction"
        >
        </rp-alert>
      </rp-overlay>
      </div>
  </section>
</template>

<script>
  /* eslint-disable array-callback-return */

  import UserForm from 'raypro_ui/src/components/ui/forms/User'
  import {createUser, getAvailableRoles, createDistributor, createHospitalAdmin} from 'raypro_ui/src/api/users'
  import {getHospitalsWithoutPagination} from 'raypro_ui/src/api/hospitals'
  import Terms from '@/components/Terms'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'
  import {getLocales} from 'raypro_ui/src/api/locales'
  import {getCountries} from 'raypro_ui/src/api/countries'

  export default {
    data() {
      return {
        errors: {},
        form: {},
        locales: [],
        localesLoaded: false,
        roleOption: [],
        genders: [
          {'label': 'Male', 'value': 'M'},
          {'label': 'Female', 'value': 'F'},
          {'label': 'Prefer not to say', 'value': 'O'}
        ],
        active: false,
        successMessage: 'User added successfully!',
        breadcrumbs: [
          {label: 'Add User'}
        ],
        title: 'Add User',
        countries: [],
        allHospitals: []
      }
    },

    mixins: [page],

    mounted() {
      getAvailableRoles().then(({data}) => {
        data.available_roles.map((role) => {
          // Need a better way to do this
          if(role.name !== 'patient') {
            return this.roleOption.push({
              key: role.name,
              value: role.id
            })
          }
        })
      })
      getCountries().then(({data}) => {
        this.countries = data
      })
      this.getLocales()
      getHospitalsWithoutPagination().then(({data}) => {
        this.allHospitals = data
      })
    },

    computed: {
      userPayload() {
        const form = this.form

        if(this.distributorRoleIsSelected()) {
          const distributor = {
            distributor: {
              profile: {
                last_name: form.last_name,
                gender: form.gender,
                first_name: form.first_name,
              },
              password: form.password,
              locale_id: form.locale_id,
              email: form.email,
              countries: form.countriesSelected.map((country) => { return country.id })
            }
          }

          return distributor
        }

        if(this.hospitalAdminRoleIsSelected()) {
          const hospitalAdmin = {
            hospital_admin: {
              profile: {
                last_name: form.last_name,
                gender: form.gender,
                first_name: form.first_name,
              },
              password: form.password,
              locale_id: form.locale_id,
              email: form.email,
              hospitals: form.hospitalsSelected.map((country) => { return country.id })
            }
          }

          return hospitalAdmin
        }

        return {
          user: {
            email: form.email,
            password: form.password,
            'user_roles': [{'role_id': form.role}],
            locale_id: form.locale_id,
            profile: {
              'first_name': form.first_name,
              'last_name': form.last_name,
              'salutation': form.salutation,
              'speciality': form.speciality,
              gender: form.gender,
            }
          }
        }
      },

      availableLocales() {
        if(this.localesLoaded) {
          const locales = []
          const allowed = ['English']

          this.locales.forEach((locale) => {
            if(allowed.includes(locale.key)) {
              locales.push(locale)
            }
          })
          return locales
        }
      }
    },

    components: {
      'rp-user-form': UserForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Terms,
      Breadcrumbs
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'all-users'})
      },

      addUser() {
        const payload = this.userPayload
        let createUserFunction = null

        if(this.distributorRoleIsSelected()) {
          createUserFunction = (payload) => { return createDistributor(payload) }
        } else if(this.hospitalAdminRoleIsSelected()) {
          createUserFunction = (payload) => { return createHospitalAdmin(payload) }
        } else {
          createUserFunction = (payload) => { return createUser(payload) }
        }
  
        createUserFunction(payload)
          .then(() => {
            this.active = true
            // alert('User added successfully!')
          })
          .catch(({response}) => {
            // TODO: map errors to flat structure for form
            // this.errors = response.errors
          })
      },

      showDob() {
        for(const i in this.roles) {
          if(this.roles[i].value === this.form.role && (this.roles[i].key === 'surgeon' || this.roles[i].key === 'nurse')) {
            return false
          }
        }
        return true
      },

      getLocales() {
        getLocales().then(({data}) => {
          this.locales = data.map((locale) => {
            return {key: locale.name, value: locale.id}
          })

          this.localesLoaded = true
        })
      },

      surgeonRoleIsSelected() {
        for(const i in this.roleOption) {
          if(this.roleOption[i].value === this.form.role && this.roleOption[i].key === 'surgeon') {
            return true
          }
        }
        return false
      },

      distributorRoleIsSelected() {
        for(const i in this.roleOption) {
          if(this.roleOption[i].value === this.form.role && this.roleOption[i].key === 'rayner_distributor') {
            return true
          }
        }
        return false
      },

      hospitalAdminRoleIsSelected() {
        for(const i in this.roleOption) {
          if(this.roleOption[i].value === this.form.role && this.roleOption[i].key === 'hospital_admin') {
            return true
          }
        }
        return false
      }
    }
  }
</script>

<style lang="sass">
  .page-user-form
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/AddUser.vue